export { default as StatsOverview } from "./StatsOverview";
export { default as PlanBreakdown } from "./PlanBreakdown";
export { default as TimelineChart } from "./TimelineChart";
export { default as SendHistory } from "./SendHistory";
export { default as PulseReportForm } from "./PulseReportForm";

// Domain colors for email providers
export const domainColors = {
  gmail: "#DB4437",
  yahoo: "#720e9e",
  hotmail: "#0078D4",
  outlook: "#0072C6",
  aol: "#31459B",
  icloud: "#999999",
  protonmail: "#8A6EFF",
  zoho: "#C52F24",
  mail: "#FF5A5F",
  yandex: "#FFCC00",
  gmx: "#FC5900",
  other: "#1890ff",
};
